/** reCAPTCHA 校验接口的固定路径。 */
const RECAPTCHA_VERIFY_PATH = '/tools/recaptcha/verify';
/** 隐私申请接口的固定路径，日志不得包含用户填写内容。 */
const DSR_SUBMIT_PATH = '/api/compliance/data_subject_requests';

/** Axios 异常中与安全日志相关的最小字段。 */
interface AxiosErrorForClientLog {
  code?: unknown;
  config?: {
    method?: string;
    url?: string;
  };
  response?: {
    status?: number;
  };
}

/**
 * 返回可写入客户端日志的 Axios 异常字符串。
 * DSR 和 reCAPTCHA 请求仅保留安全摘要，其他接口延续原有序列化行为。
 */
export function serializeAxiosErrorForClientLog(error: unknown): string | undefined {
  const axiosError = error as AxiosErrorForClientLog;
  const rawUrl = axiosError?.config?.url;
  const requestPath = rawUrl?.split('?')[0];

  if (rawUrl?.split(/[?#]/)[0].replace(/\/+$/, '').endsWith(DSR_SUBMIT_PATH)) {
    const rawStatus = axiosError.response?.status;
    const status =
      typeof rawStatus === 'number' &&
      Number.isInteger(rawStatus) &&
      rawStatus >= 100 &&
      rawStatus <= 599
        ? rawStatus
        : undefined;
    let kind = 'request_error';
    if (axiosError.code === 'ERR_CANCELED') kind = 'canceled';
    else if (status !== undefined) kind = 'http_error';
    else if (axiosError.code === 'ECONNABORTED' || axiosError.code === 'ETIMEDOUT')
      kind = 'timeout';
    else if (axiosError.code === 'ERR_NETWORK') kind = 'network_error';

    // 白名单输出：不序列化原异常，message/stack/response 也可能回显申请内容。
    return JSON.stringify({
      event: 'dsr_submit_failed',
      method: 'POST',
      path: DSR_SUBMIT_PATH,
      status,
      kind,
    });
  }

  if (requestPath?.endsWith(RECAPTCHA_VERIFY_PATH)) {
    return JSON.stringify({
      event: 'recaptcha_verify_request_failed',
      method: axiosError.config?.method?.toUpperCase(),
      path: RECAPTCHA_VERIFY_PATH,
      status: axiosError.response?.status,
    });
  }

  return JSON.stringify(error);
}
